'use strict';

function PhotoGallery() {
  $('.paragraph--type--photo-gallery .field--name-field-gallery-images img, .paragraph--type--photo-gallery .field--name-field-content-image img').wrap(function () {
    return String().concat('<a href="', $(this).attr("src"), '" data-fancybox="photo-gallery" data-caption="', ($(this).attr("title") || $(this).attr("alt")), '" data-title="', $(this).attr("alt"), '"></a>');
  });
  if ($(".page-node-type-landing-page").length > 0) {
    var slickOptions = ({
      infinite: false,
      slidesToShow: 4,
      prevArrow: '<button class="slick-prev"><i class="icon-chevron-left"></i><span>Previous</span></button>',
      nextArrow: '<button class="slick-next"><i class="icon-chevron-right"></i><span>Next</span></button>',
      rows: $('.paragraph--type--photo-gallery .field--name-field-gallery-images').length > 3 ? 2 : 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            rows: $('.paragraph--type--photo-gallery .field--name-field-gallery-images').length > 3 ? 2 : 1,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            rows: $('.paragraph--type--photo-gallery .field--name-field-gallery-images').length > 2 ? 2 : 1,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            rows: 2,
            slidesToShow: 1
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        }]
    });
    $('.paragraph--type--photo-gallery .field--name-field-gallery-images').slick(slickOptions).prepend(imageHTML);
  }
};
export default PhotoGallery;
